// extracted by mini-css-extract-plugin
module.exports = {"purchaseForm":"Form03_purchaseForm__Xp4U0","purchaseFormContainer":"Form03_purchaseFormContainer__COou8"};